"use client";
import { jsx } from "react/jsx-runtime";
import { useMediaQuery, Divider as Divider$1 } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ColorGray500 } from "@nxt-costco-com/forge-design-tokens";
import { getDataTestId } from "../../Util/index.js";
import { COMPONENT_NAME } from "./constants.js";
const Divider = ({
  orientation = "horizontal",
  mobileOrientation,
  mobileBreakpoint,
  sx = [],
  uniqueId
}) => {
  const theme = useTheme();
  if (!mobileBreakpoint) {
    mobileBreakpoint = theme.breakpoints.between("xs", "md");
  }
  const isMobile = useMediaQuery(mobileBreakpoint);
  return /* @__PURE__ */ jsx(
    Divider$1,
    {
      orientation: isMobile && mobileOrientation ? mobileOrientation : orientation,
      "aria-hidden": true,
      sx: [
        {
          background: ColorGray500,
          minWidth: isMobile && (mobileOrientation === "horizontal" || !mobileOrientation && orientation === "horizontal") ? "100%" : void 0
        },
        ...Array.isArray(sx) ? sx : [sx]
      ],
      "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
      flexItem: true
    }
  );
};
Divider.displayName = COMPONENT_NAME;
export {
  Divider
};
